interface Props {
  courseIn: string
  courseOut: string
  className?: string
}

export const RateDisplayMobile: React.FC<Props> = ({ courseIn, courseOut, className }) => {
  return (
    <div className={className}>
      <div className={'flex flex-col text-sm w-full gap-1'}>
        <div className="flex justify-between gap-x-4">
          <div className="font-klein font-medium text-main-black dark:text-white">Входящие:</div>
          <div className="font-klein font-medium text-main-black dark:text-white">
            1 USDT = {courseIn}
          </div>
        </div>
        <div className="flex justify-between gap-x-4">
          <div className="font-klein font-medium text-main-black dark:text-white">Исходящие:</div>
          <div className="font-klein font-medium text-main-black dark:text-white">
            1 USDT = {courseOut}
          </div>
        </div>
      </div>
    </div>
  )
}
